// extracted by css-extract-rspack-plugin
export default {"promptText":"_ae3d04a5","buttonWrapper":"_19915979","cancelButton":"_a60bee6c","deleteButton":"_3d41fff3"};